module.exports = __webpack_public_path__ + "static/img/jq-product-lc-bg.5f5c7ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jq-product-lc-bg.png
// module id = /z2r
// module chunks = 1